import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "backdrop"]
  static values = {
    nextLessonUrl: String,
    nextLessonId: String,
    courseUuid: String,
    nextLessonIntroViewed: Boolean
  }

  show() {
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
    this.pauseVideo()
  }

  hide() {
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }

  pauseVideo() {
    // Find the course-lesson controller and pause the video
    const courseLessonElement = document.querySelector('[data-controller="course-lesson"]')
    if (courseLessonElement) {
      const stimulus = window.Stimulus || this.application
      const courseLessonController = stimulus.getControllerForElementAndIdentifier(
        courseLessonElement,
        'course-lesson'
      )

      if (courseLessonController && courseLessonController.player) {
        try {
          courseLessonController.player.pauseVideo()
        } catch (error) {
          console.warn('Could not pause video:', error)
        }
      }
    }
  }

  closeOnBackdrop(event) {
    // Only close if clicking the backdrop itself (not the content)
    if (event.target === this.backdropTarget) {
      this.hide()
    }
  }

  watchAgain(event) {
    event.preventDefault()

    // Find the course-lesson controller and dispatch replay event
    const courseLessonElement = document.querySelector('[data-controller="course-lesson"]')
    if (courseLessonElement) {
      const replayEvent = new CustomEvent('lesson-interstitial:replay', {
        bubbles: true,
        detail: { action: 'replay' }
      })
      courseLessonElement.dispatchEvent(replayEvent)
    }

    this.hide()
  }

  continueToNext(event) {
    event.preventDefault()
    this.hide()

    // Check if user has seen intro for next lesson before (from database)
    if (this.nextLessonIntroViewedValue) {
      // Direct navigation
      window.location.href = this.nextLessonUrlValue
    } else {
      // Show intro modal
      this.dispatch('showNextIntro', { bubbles: true })
    }
  }
}
